import React, { useState, useEffect, useRef } from "react";

const HorizontalScale = ({ min = 0, max = 100, interval = 10, onChange }) => {
  const steps = [];
  for (let i = min; i <= max; i += interval) {
    steps.push(i);
  }

  const [position, setPosition] = useState(min);
  const containerRef = useRef(null);
  const stepRefs = useRef({});
  const [iconLeft, setIconLeft] = useState(0);

  useEffect(() => {
    const stepEl = stepRefs.current[position];
    if (stepEl && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const stepRect = stepEl.getBoundingClientRect();
      const leftPos = stepRect.left - containerRect.left + stepRect.width / 2;
      setIconLeft(leftPos);
    }
  }, [position, onChange]);

  return (
    <div className="flex gap-4 p-4">
      <p className="text-sm">Select Miles</p>
      <div className="w-full flex flex-col items-center">
        <div
          ref={containerRef}
          className="w-full relative flex justify-between items-end bg-info-50 px-4 pt-5 rounded"
          style={{ userSelect: "none" }}
        >
          {steps.map((step) => (
            <div
              key={step}
              ref={(el) => (stepRefs.current[step] = el)}
              className="flex flex-col items-center cursor-pointer relative"
              style={{ minWidth: 30 }}
              onClick={() => {
                setPosition(step);
                if (onChange) onChange(step);
              }}
            >
              {position !== step && (
                <div className="w-[1px] h-4 bg-gray-600 rounded"></div>
              )}
              <div className="absolute top-full mt-1">
                <span
                  className={`text-sm ${
                    position === step
                      ? "bg-orange-500 text-white px-2 py-1 rounded-lg"
                      : ""
                  }`}
                >
                  {step}
                </span>
              </div>
            </div>
          ))}
          <span
            className="material-symbols-outlined text-3xl absolute bottom-2"
            style={{
              left: iconLeft,
              transform: "translateX(-50%)",
              transition: "left 400ms ease",
              pointerEvents: "none",
            }}
          >
            directions_run
          </span>
        </div>
      </div>
    </div>
  );
};

export default HorizontalScale;
